import { render, staticRenderFns } from "./menu-admin.vue?vue&type=template&id=dbcb580a&scoped=true&"
import script from "./menu-admin.vue?vue&type=script&lang=js&"
export * from "./menu-admin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbcb580a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\Vuejs-Project\\subsappadminOrg\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dbcb580a')) {
      api.createRecord('dbcb580a', component.options)
    } else {
      api.reload('dbcb580a', component.options)
    }
    module.hot.accept("./menu-admin.vue?vue&type=template&id=dbcb580a&scoped=true&", function () {
      api.rerender('dbcb580a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/menus/menu-admin.vue"
export default component.exports